import { useFormikContext, getIn } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as ArrowTop } from "assets/icons/ArrowTop.svg";
import { ReactComponent as ArrowDown } from "assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowRight } from "assets/icons/arrow-right.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg"; // add an X icon SVG
import "./style.scss";
import { LabelField, HintField } from "components";
import { fontConfig } from "theme/fontConfig";

const SelectMenu = ({
  options,
  loading,
  name,
  subField,
  title,
  primaryLabelKey = "label",
  secondaryLabelKey = "label",
  secondaryMapKey,
  mandatory = "false",
  handleChange,
  isClearable,
}) => {
  const menuRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activePrimary, setActivePrimary] = useState(null);
  const [activeSubMenuId, setActiveSubMenuId] = useState(null);

  const { values, setFieldValue, errors, touched } = useFormikContext();

  const getError = getIn(errors, name);
  const getTouch = getIn(touched, name);
  const selectedPrimary = getIn(values, name);
  const selectedSecondary = getIn(values, subField);

  useEffect(() => {
    const handler = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setIsMenuOpen(false);
        setActiveSubMenuId(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handlePrimaryClick = (item) => {
    setFieldValue(name, {
      id: item._id,
      name: item[primaryLabelKey],
    });
    setFieldValue(subField, undefined);
    setActiveSubMenuId(null);
    handleChange && handleChange(item);
  };

  const handleSecondaryClick = (subItem, activePrimary) => {
    if (!activePrimary) return;
    setFieldValue(name, {
      id: activePrimary._id,
      name: activePrimary[primaryLabelKey],
    });
    setFieldValue(subField, {
      id: subItem._id,
      name: subItem[secondaryLabelKey],
    });
    setActiveSubMenuId(null);
    handleChange && handleChange({ ...activePrimary, ...subItem });
  };

  const handleClearSelection = (e) => {
    e.stopPropagation();
    setFieldValue(name, undefined);
    setFieldValue(subField, undefined);
    setActivePrimary(null);
    setActiveSubMenuId(null);
    setIsMenuOpen(false);
    handleChange && handleChange(null);
  };

  const hasSelection = selectedPrimary?.name || selectedSecondary?.name;

  return (
    <>
      <LabelField
        mandatory={mandatory}
        title={title}
        style={{
          fontFamily: fontConfig.GeneralLabelFieldFont.family,
          fontWeight: "400",
          fontSize: "12px",
          color: "#4F4F4F",
          margin: "0px 0px 8px 0px",
        }}
      />

      <div className="class_LedgersMenu" ref={menuRef}>
        <button
          className="class_LedgersMenu_btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          type="button"
        >
          {(selectedPrimary?.name || selectedSecondary?.name) && (
            <div className="ledger_value">
              {selectedPrimary?.name || ""}
              <span>{selectedSecondary?.name || ""}</span>
            </div>
          )}

          {!selectedPrimary?.name && !selectedSecondary?.name && (
            <span className="w-100 text-left class_select_span">
              Select Option
            </span>
          )}

          {isMenuOpen && (
            <ul className="ledgers_ul">
              {options?.map((item) => {
                const hasChildren = item[secondaryMapKey]?.length > 0;
                return (
                  <li
                    key={item._id}
                    className={
                      hasChildren ? "ledgers_li_with_subLed" : "ledgers_li"
                    }
                    onMouseEnter={() => {
                      setActiveSubMenuId(item._id);
                      setActivePrimary(item);
                    }}
                  >
                    <div
                      onClick={() => handlePrimaryClick(item)}
                      className="w-100 text-left h-100"
                    >
                      {item[primaryLabelKey]}
                    </div>
                    {hasChildren && <ArrowRight />}
                  </li>
                );
              })}
            </ul>
          )}

          {activeSubMenuId === activePrimary?._id && (
            <ul
              className="sub_ledgers_ul"
              onMouseLeave={() => setActiveSubMenuId(null)}
            >
              {activePrimary[secondaryMapKey]?.map((subItem) => (
                <li
                  key={subItem._id}
                  className="sub_ledgers_li"
                  onClick={() => handleSecondaryClick(subItem, activePrimary)}
                >
                  {subItem[secondaryLabelKey]}
                </li>
              ))}
            </ul>
          )}

          {loading ? (
            <span className="mr-loader spinner spinner-gray"></span>
          ) : hasSelection && isClearable ? (
            <span
              className="clear-btn"
              onClick={handleClearSelection}
              title="Clear selection"
            >
              <CloseIcon />
            </span>
          ) : isMenuOpen ? (
            <ArrowTop />
          ) : (
            <ArrowDown />
          )}
        </button>
      </div>

      {(getTouch?.id || getTouch) && getError?.id ? (
        <HintField error={getError?.name} />
      ) : null}
    </>
  );
};

export default SelectMenu;
